import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../components/Base/Base';
import { Interactive } from '../../components/Base/Interactive/Interactive';
import { Text } from '../../components/Base/Text';
import { SrOnly } from '../../components/Helper/SrOnly/SrOnly';
import Spinner from '../../components/Spinner';
import Svg from '../../components/Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var svgStyles = {
  "root": "SVG-root_1gLEH",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-accent": "SVG-fill-accent_hrCaj",
  "fill-neutral-weak": "SVG-fill-neutral-weak_RUQEU",
  "fill-neutral-plain": "SVG-fill-neutral-plain_3jzV-",
  "fill-neutral-strong": "SVG-fill-neutral-strong_2iDzN",
  "fill-disabled": "SVG-fill-disabled_2Wv9a",
  "fill-informative": "SVG-fill-informative_2TJ7Q",
  "fill-positive": "SVG-fill-positive_A2UHl",
  "fill-notice": "SVG-fill-notice_99WSg",
  "fill-negative": "SVG-fill-negative_2JTXR"
};
var styles = {
  "root": "Action-root_1sbvN Widget-widgetFluidHeight_3_KT_ Widget-centered_2NDSy",
  "icon": "Action-icon_1pHHW",
  "label": "Action-label_3TGWM",
  "compact": "Action-compact_2mm0U Widget-widget__NYoi Widget-base_2xffH Widget-widgetFixedWidth_aNuHK",
  "wide": "Action-wide_2Biwb Widget-xsm-widget_TtU9B Widget-base_2xffH",
  "block": "Action-block_3MKJH",
  "wrapper": "Action-wrapper_3wPf7",
  "withPopover": "Action-withPopover_3n254",
  "isDisabled": "Action-isDisabled_2A6Lq",
  "base-white": "Action-base-white_3Be7f",
  "base-green": "Action-base-green_211wh",
  "base-success": "Action-base-success_3VFIl",
  "base-danger": "Action-base-danger_1Xr3W",
  "base-disabled": "Action-base-disabled_b3RtN",
  "hover-green": "Action-hover-green_3Q75t",
  "hover-green-dark": "Action-hover-green-dark_21qiE",
  "hover-success": "Action-hover-success_1Y4nS",
  "hover-success-dark": "Action-hover-success-dark_3XEeO",
  "hover-danger": "Action-hover-danger_1UwXc",
  "hover-danger-dark": "Action-hover-danger-dark_VEh7y"
};
const themesMap = {
  green: {
    base: 'white',
    color: 'base',
    fill: 'neutral-strong',
    hover: 'green'
  },
  'green-plain': {
    base: 'green',
    color: 'white',
    fill: 'white',
    hover: 'green-dark'
  },
  success: {
    base: 'white',
    color: 'base',
    fill: 'positive',
    hover: 'success'
  },
  'success-plain': {
    base: 'success',
    color: 'white',
    fill: 'white',
    hover: 'success-dark'
  },
  danger: {
    base: 'white',
    color: 'base',
    fill: 'negative',
    hover: 'danger'
  },
  'danger-plain': {
    base: 'danger',
    color: 'white',
    fill: 'white',
    hover: 'danger-dark'
  },
  disabled: {
    base: 'disabled',
    color: 'light',
    fill: 'disabled'
  }
};
class Action extends React.Component {
  static defaultProps = {
    variant: 'compact',
    theme: 'green'
  };
  classOf = key => this.props.classes?.[key] ?? '';
  computeTheme() {
    const themeName = this.props.disabled || this.props.loading ? 'disabled' : this.props.theme;
    return themesMap[themeName];
  }
  computeAddon() {
    if (this.props.loading) {
      return 'loader';
    }
    if (typeof this.props.popoverIcon === 'object' && /block|wide/.test(this.props.variant) && this.props.disabled) {
      return 'popover';
    }
    if (typeof this.props.icon === 'string' && Svg.has(this.props.icon)) {
      return 'icon';
    }
    return '';
  }
  computeTitle() {
    if (typeof this.props.title === 'string') {
      return this.props.title;
    }
    if (this.props.variant === 'compact' && typeof this.props.children === 'string') {
      return this.props.children;
    }
    return null;
  }
  render() {
    const {
      theme,
      classes,
      icon,
      popoverIcon,
      variant,
      loading,
      active,
      disabled,
      children,
      title,
      className,
      ...extraProps
    } = this.props;
    const computedTheme = this.computeTheme();
    const computedTitle = this.computeTitle();
    const addon = this.computeAddon();
    const hasLoader = addon === 'loader';
    const hasPopover = addon === 'popover';
    const hasIcon = addon === 'icon';
    const isDisabled = disabled || hasLoader;
    const isBlock = variant === 'block';
    const rootClasses = clsx(styles.root, styles[variant], computedTheme.base && styles[`base-${computedTheme.base}`], computedTheme.hover && styles[`hover-${computedTheme.hover}`], !hasPopover && isDisabled && styles.isDisabled, hasPopover && styles.withPopover, this.classOf('root'), className);
    const wrapperClasses = clsx(styles.wrapper, this.classOf('wrapper'));
    const labelClasses = clsx(styles.label, this.classOf('label'));
    const iconClasses = clsx(styles.icon, computedTheme.fill && svgStyles[`fill-${computedTheme.fill}`], this.classOf('icon'));
    return /*#__PURE__*/_jsx(Interactive, {
      tagName: hasPopover ? 'span' : undefined,
      hoverable: !!computedTheme.hover,
      interactive: !!computedTheme.hover,
      title: computedTitle,
      disabled: isDisabled,
      separatorLeft: !isBlock,
      className: rootClasses,
      ...extraProps,
      children: /*#__PURE__*/_jsxs(Base, {
        tagName: "span",
        flex: true,
        flexGrow1: true,
        flexAlignItemsCenter: true,
        flexJustifyCenter: !isBlock,
        flexJustifyBetween: isBlock,
        paddingRight: isBlock ? 'small' : null,
        paddingLeft: isBlock ? 'small' : null,
        className: wrapperClasses,
        children: [/*#__PURE__*/_jsx(Label, {
          variant: variant,
          color: computedTheme.color,
          className: labelClasses,
          children: children
        }), hasLoader && /*#__PURE__*/_jsx(Spinner, {
          name: "dots"
        }), hasIcon && icon && /*#__PURE__*/_jsx(Svg, {
          name: icon,
          size: "5x",
          className: iconClasses,
          focusable: "false"
        }), hasPopover && popoverIcon && /*#__PURE__*/React.cloneElement(popoverIcon)]
      })
    });
  }
}
function Label({
  variant,
  color,
  ...extraProps
}) {
  let component;
  if (variant === 'compact') {
    component = /*#__PURE__*/_jsx(SrOnly, {
      ...extraProps
    });
  }
  if (variant === 'wide') {
    component = /*#__PURE__*/_jsx(SrOnly, {
      xsm: true,
      ...extraProps
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    weight: "regular",
    align: "start",
    color: color,
    component: component,
    ...extraProps
  });
}
export default Action;